<!--  -->
<template>
    <div class="xiangqing">
        <h2>
            <span>{{isEnglish?'Scenic spot information':'景区信息'}}  </span>
        </h2>
        <ul>
            <li>
                <span> {{isEnglish ? 'development time':'开放时间'}} </span>
                <span>{{tourInfo.start_time +' — '+tourInfo.end_time}}</span>
            </li>
            <li>
                <span> {{isEnglish ? 'contact number':'联系电话'}} </span>
                <span>
                    <a :href="'tel:'+tourInfo.settings.phone">
                        {{tourInfo.settings.phone}}
                    </a>
                </span>
            </li>
            <li>
                <span>{{ isEnglish ?  'Scenic spot address':'景区地址'}} </span>
                <span>
                    {{tourInfo.address}}
                </span>
            </li>
            <li>
                <span> {{ isEnglish ?  'Overview of scenic spots':'景区概述'}} </span>
                
                <div>
                    <p v-show="!isEnglish" v-html="tourInfo.content"></p>
                    <p v-show="isEnglish" v-html="tourInfo.content_eng"></p>

                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tourInfo:{},
            isEnglish:false
        }
    },
    created() {
         this.tourInfo=JSON.parse(localStorage.getItem("tourInfo"))
         this.isEnglish=this.$route.query.isEnglish
    },
    mounted() {},
    methods: {},
}
</script>
<style scoped lang='scss'>
 .xiangqing{
     padding: .2rem ;
     box-sizing: border-box;
 }
 h2{
    font-size: 20px;
    font-weight: normal;
    color: #555;
    span{
        border-bottom: 5px solid 	#FFD700;
    }
}
ul{
    list-style: none;
    
    li{
        width: 100%;
        list-style: none;
        font-size: .26rem;
        padding-top: .2rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        height: 40px;
        >span:first-child{
            display: flex;
            padding-right: .2rem;
            box-sizing: border-box;
        }
    }
    li:nth-child(3){
        height: auto;
        display: flex;
        align-items: flex-start;
        >span:last-child{
            flex: 1;
            
            display: flex;
            flex-wrap: wrap;
        }
    }
    li:nth-child(4){
        display: flex;
        flex-direction: column;
        // justify-content: flex-start;
        align-items: flex-start;
        >div{
            text-indent: .6rem;
            padding-top:30px;
            box-sizing: border-box;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/tourMessage.vue